module.exports = __webpack_public_path__ + "static/media/border-bottom.25f177ff.svg";